module.exports = __webpack_public_path__ + "img/Bank_Hapoalim.8e599e0a.svg";